export default "/images/4527eadc2706c8b1217171e6c66af154.avif";